import { connect } from 'react-redux';

import { ServerStatus } from '@/models/globalModels';
import { RootState } from '@/redux/rootReducer';

const mapDispatchToProps = {};

const mapStateToProps = (state: RootState) => {
  const auth = state.auth;
  return {
    companyStatus: auth.companyStatus,
  };
};

const CompanyChecker = ({ children, companyStatus }: { children: JSX.Element; companyStatus?: ServerStatus }) => {
  // Valid Company
  if (companyStatus == ServerStatus.FETCH) return children;
  // Invalid Company
  else if (companyStatus == ServerStatus.FETCH_ERROR) return null;
  // less than 1ms while the server save the data into redux state
  else return <></>;
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyChecker);
